<template>
  <div
    class="bgPage min-height-for-section w-100 d-flex justify-content-center align-items-center"
  >
    <div class="container-fluid my-4">
      <div class="row mt-md-5">
        <div class="col-12">
          <div
            class="w-100 d-flex flex-column align-items-center justify-content-center mb-4"
          >
            <div class="icon-logo mb-3">
              <img
                src="../assets/RTMKlik_favicon_curve.png"
                class="w-100 h-100"
                alt=""
              />
            </div>
            <div class="w-100 header-container">
              <h3 class="header-text my-2">
                RTMKLIK AKAUN
              </h3>
              <p class="mb-0 header-desc">
                Selamat datang! Sila masukkan e-mel untuk tukar kata laluan.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-4">
              <h2 class="header-text">Lupa kata laluan</h2>
              <p class="header-desc">
                Kami akan menghantar arahan untuk set semula kata laluan anda
              </p>
              <div class="w-100 mt-4">
                <!-- form -->
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.email)"
                  >
                    <label class="w-100 inputLabelText">E-mel</label>
                    <input
                      type="email"
                      name="email"
                      class="form-control"
                      required
                      v-model.lazy="model.email"
                      email-sld
                    />

                    <field-messages
                      name="email"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" class="error">
                        Sila masukkan e-mel anda
                      </div>
                      <div slot="email-sld" class="error">
                        Sila masukkan e-mel yang betul
                      </div>
                    </field-messages>
                  </validate>

                  <div class="py-2 text-center w-100">
                    <button class="modal-default-button" type="submit">
                      Hantar
                    </button>
                  </div>
                </vue-form>
              </div>
              <div class="w-100 my-2 error" v-if="errorMsg">
                {{ errorMsg }} . Please try again.
              </div>
              <div class="w-100 my-2 success" v-if="successMsg">
                Kami telah menghantar e-mel kepada anda untuk pengesahan.Sila
                semak e-mel anda.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
export default {
  data() {
    return {
      formstate: {},
      errorMsg: "",
      model: {
        email: "",
      },
      successMsg: false,
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    onSubmit: function(e) {
      e.preventDefault();
      // console.log(this.model.email);

      let url = "https://rtm.glueapi.io/v2/user/temporaryToken";
      let body = {
        type: "reset-password",
        email: this.model.email,
      };

      let vm = this;
      axios
        .post(url, body)
        .then((response) => {
          if (response.status == 200 || response.status == "200") {
            vm.successMsg = true;
          }
          vm.errorMsg = "";
        })
        .catch(function(error) {
          // vm.errorMsg = error
          vm.errorMsg = error.response.data.error.displayMessage;
        });
    },
  },
};
</script>

<style scoped>
.min-height-for-section {
  min-height: 80vh;
  padding: 4rem 0;
}
.bgPage {
  background: url("../assets/rtmklik/bg-login-v2.png") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.icon-logo {
  width: 80px;
  height: 80px;
}

.header-container {
  max-width: 480px;
}
.header-text {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.header-desc {
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  border-radius: 12px;
  background: #171f26;
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06),
    0px 4px 8px -2px rgba(16, 24, 40, 0.1);
}
.inputLabelText {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
}
.form-control {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: flex;
  padding: 10px 14px;
  align-items: center;
}
.form-control:focus {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.modal-default-button {
  width: 100%;
  display: flex;
  padding: 10px 18px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  background: #d9e021;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
  outline: none;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.modal-text {
  margin-top: 0;
  font-size: 30px;
  font-weight: bolder;
  line-height: 1.2;
  color: #dae12f;
}
.modal-text-small {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: #dae12f;
}
.signup-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #dae12f;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  /* background: #111319; */
  border-radius: 4px;
}
.text-yellow {
  color: #dae12f;
}
.text-black {
  color: black;
}
.text-gray {
  color: #6c757d;
}
.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 14px;
  color: black;
  text-align: left;
}
.form-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #dae12f;
}
.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 14px;
  margin-top: 4px;
}
h1 {
  overflow: hidden;
  text-align: center;
}

h1:before,
h1:after {
  background-color: #dae12f;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
  color: #dae12f;
}

h1:before {
  right: 0.5em;
  margin-left: -50%;
}

h1:after {
  left: 0.5em;
  margin-right: -50%;
}
</style>
